export default __webpack_public_path__ + "static/media/tasklist.4383bf9f.png";